import { Card, H2, Separator } from '@betterment/samba-react';

import { CashAccountRow } from './components/CashAccountRow';
import { InvestingAccountRow } from './components/InvestingAccountRow';

import { accountsByType } from '../../../shared/utils';
import { PerformanceAccountsQuery } from '../../graphql/performanceAccounts.generated';

export const AccountsCard: React.FC<{
  accounts: PerformanceAccountsQuery['performance']['accounts'];
}> = ({ accounts }) => {
  if (accounts.length === 0) {
    return null;
  }

  const { cashAccounts, investingAccounts } = accountsByType(accounts);

  return (
    <>
      {investingAccounts.length > 0 && (
        <Card>
          <Card.Header css={{ padding: 'space.300' }}>
            <H2 variant="title200">Investments</H2>
          </Card.Header>
          <Separator css={{ fullWidthWithInset: 'space.300' }} />
          <Card.Content>
            {investingAccounts.map(a => (
              <InvestingAccountRow key={a.id} account={a} />
            ))}
          </Card.Content>
          <Card.Footer css={{ padding: 'space.300' }}>How to understand your returns</Card.Footer>
        </Card>
      )}
      {cashAccounts.length > 0 && (
        <Card>
          <Card.Header css={{ padding: 'space.300' }}>
            <H2 variant="title200">Cash</H2>
          </Card.Header>
          <Card.Content>
            {cashAccounts.map(a => (
              <CashAccountRow key={a.id} account={a} />
            ))}
          </Card.Content>
        </Card>
      )}
    </>
  );
};
